import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import s from './Hint.module.css';

import { ReactComponent as InfoIcon } from 'icons/info.svg';

const Hint = ({ text, position, formatting, className, ...rest }) => {
  const textLength = text.length || text.props?.children?.map(({ props }) => props?.children).join('').length;
  return (
    <div className={cn(s.wrap, className)} {...rest}>
      <div className={cn(s.root, s[position], { [s.formatting]: formatting })}>
        <InfoIcon />
        <span
          className={cn(s.content, {
            [s.small]: textLength < 19,
            [s.md]: textLength > 19 && textLength.lenth < 100,
            [s.big]: textLength > 100,
          })}
        >
          {text}
        </span>
      </div>
    </div>
  );
};

Hint.propTypes = {
  formatting: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  position: PropTypes.oneOf(['up', 'down']),
};

Hint.defaultProps = {
  formatting: false,
  position: 'up',
};

export default Hint;
